export default __webpack_public_path__ + "static/media/abfn-cert.cda22c9b.png";